import { clone } from 'lodash';
import * as PIXI from 'pixi.js-legacy';
window.PIXI = PIXI;

class CameraSystem {
  constructor(systems) {
    this.systems = systems;
  }

  before(dt) {
  }

  after(dt) {
  }

  update(dt, ent) {
  if (!ent.camera.active) {
    return;
  }
  this.systems.noCamera = false;

  if (!this.systems.cameraDt) {
    this.systems.cameraDt = 0;
  }
  this.systems.cameraDt += dt;
  if (!this.systems.gameobjects.foundCamera) {
    this.systems.gameobjects.foundCamera = false;
  }


  const {screenWidth, screenHeight, gameWidth, gameHeight} = this.systems.gameobjects;
//  this.debug.startSystem('updateCamera', length);

  if (ent.camera.active && this.systems.gameobjects.foundCamera === ent) {
    if (!ent.camera.__addComponents) {
      const slots = this.systems.findSlots(ent, ent.camera);
      this.systems.addComponent(ent, slots);
      ent.transform.isDirty = 10;
      ent.camera.__addComponents = true;
    } else {
    }
    if (!this.systems.isDirty(ent) && !this.systems.isAnyParentDirty(ent)) {
      return;
    }
    const container = this.systems.pixiContainers[ent.uuid.uuid];
    this.systems.cameraContainer.scale.x = ent.camera.scale.x / (ent.transform.scale.x * ent.transform.localScale.x);
    this.systems.cameraContainer.scale.y = ent.camera.scale.y / (ent.transform.scale.y * ent.transform.localScale.y);
    //const worldPos = ent.transform;
    const worldPos = this.systems.getWorldPosition(ent);

    this.systems.cameraContainer.pivot.x = worldPos.x;
    this.systems.cameraContainer.pivot.y = worldPos.y
    //this.gameobjects.app.stage.pivot.x = worldPos.x * thisBlockSize;
    //this.gameobjects.app.stage.pivot.y = worldPos.y * thisBlockSize;

    if (this.systems.enableLetterbox && this.systems.letterBox) {
      this.systems.letterBox.position.x = this.systems.gameobjects.app.stage.pivot.x
      this.systems.letterBox.position.y = this.systems.gameobjects.app.stage.pivot.y
    }

    this.systems.cameraContainer.alpha = ent.transform.alpha;
    const cc = this.systems.cameraContainer;
    if (cc && cc.transform && cc.parent && cc.parent.transform) {
      this.systems.cameraContainer.updateTransform();
    }

    return;

  } else {
    if (!this.systems.isDirty(ent) && !this.systems.isAnyParentDirty(ent)) {
      return;
    }
  }
  //if (this.gameobjects.foundCamera) {
    //continue;
  //}
  //throw new Error('lel');

  if (this.systems.gameobjects.foundCamera !== ent) {
    if (!ent.camera.__addChildren) {
      this.systems.createSceneGraphChildren(ent, ent.transform);
      ent.camera.__addChildren = true;
    }
  }

  ent.addTag('camera');
  this.systems.endOfFrame.push( () => {
    this.systems.gameobjects.foundCamera = ent;
  });


  //const cols = parseInt(aspects[0]);
  //const rows = parseInt(aspects[1]);
  //
  const cols = this.systems.gameobjects.game.cols || 12;
  const rows = this.systems.gameobjects.game.rows || 16;
  const game = {
    cols,
    rows
  }
  //let aspects = this.systems.overrideAspect || ent.camera.aspect.split('x');
  let aspects = [cols,rows];
  if (this.systems.gameobjects.overrideCamera) {
    if (this.systems.gameobjects.overrideCamera.aspect) {
      aspects = this.systems.gameobjects.overrideCamera.aspect;
    }
    if (this.systems.gameobjects.overrideCamera.zoom) {
      ent.camera.zoom = this.systems.gameobjects.overrideCamera.zoom;
    }
  }

  const aspect = cols / rows;
  const cx = screenWidth / 2;
  const cy = screenHeight / 2;
  const container = this.systems.pixiContainers[ent.uuid.uuid];

  let MAGIC_CAMERA_SCALE_VALUE;
  let thisBlockSize;
  if (aspect < 1) {
    thisBlockSize = Math.min(
      screenWidth / cols,
      screenHeight / rows,
      //Math.min(screenHeight / cols, screenWidth / rows)
    );

    //thisBlockSize = screenWidth / cols;
    MAGIC_CAMERA_SCALE_VALUE = thisBlockSize;

    this.systems.gameobjects.app.stage.position.x = screenWidth/2
    this.systems.gameobjects.app.stage.position.y = screenHeight/2;

    this.systems.cameraContainer.scale.x = MAGIC_CAMERA_SCALE_VALUE / ent.camera.zoom
    this.systems.cameraContainer.scale.y = MAGIC_CAMERA_SCALE_VALUE / ent.camera.zoom
    ent.camera.scale = clone(this.systems.cameraContainer.scale);
    //this.cameraContainer.position.x = 0;
    //this.cameraContainer.position.y = 0;
  } else {
    thisBlockSize = Math.min(
      screenWidth / cols,
      screenHeight / rows,
      //Math.min(screenHeight / cols, screenWidth / rows)
    );
    MAGIC_CAMERA_SCALE_VALUE = thisBlockSize;
    this.systems.gameobjects.app.stage.position.x = screenWidth/2;
    this.systems.gameobjects.app.stage.position.y = screenHeight/2;

    this.systems.cameraContainer.scale.x = MAGIC_CAMERA_SCALE_VALUE / ent.camera.zoom
    this.systems.cameraContainer.scale.y = MAGIC_CAMERA_SCALE_VALUE / ent.camera.zoom

    ent.camera.scale = clone(this.systems.cameraContainer.scale);
  }

  if (this.systems.transparent && !this.systems.background) {
    const backgroundColor = parseInt(this.systems.gameobjects.game.bgcolor.replace('#','0x'));
    const boxies = new PIXI.Graphics();
    boxies.beginFill(backgroundColor);
    const width = this.systems.gameobjects.app.renderer.width / this.systems.gameobjects.app.renderer.resolution;
    const height = this.systems.gameobjects.app.renderer.height / this.systems.gameobjects.app.renderer.resolution;
    boxies.drawRect(-width/2 - 10, -height/2 - 10, width + 20, height + 20);
    //boxies.cacheAsBitmap = true;
    const boxiesLayer = new PIXI.display.Layer();
    // I don't understand why just a zIndex is sufficient
    boxies.zIndex = -99999;
    this.systems.gameobjects.app.stage.addChild(boxies);

    this.systems.background = boxies;
  } else if (this.systems.transparent && !this.systems.background.cacheAsBitmap && this.systems.delayFirstRenderCounter < 0 ) {
    this.systems.background.cacheAsBitmap = true;
  }
  if (this.systems.enableLetterbox && !this.systems.letterBox) {
    const center = {
      x:screenWidth/2,
      y:screenHeight/2
    }
    //const letterBoxColor = parseInt(this.tiledata.game.bgcolor.replace('#','0x'));
    if (!this.systems.gameobjects.game || !this.systems.gameobjects.game.bgcolor) {
      return;
    }

    //const letterBoxColor = parseInt(this.gameobjects.game.bgcolor.replace('#','0x'));
    const letterBoxColor = 0x000000;
    const leftX = center.x + cols/2 * thisBlockSize;

    const letterBox = new PIXI.Container();

    const boxies = new PIXI.Graphics();
    boxies.beginFill(letterBoxColor);

    boxies.drawRect(cols/2 * thisBlockSize, -screenHeight, screenWidth, screenHeight*2);
    boxies.drawRect(-cols/2 * thisBlockSize - screenWidth, -screenHeight, screenWidth, screenHeight*2);

    boxies.drawRect(-screenWidth, -rows/2 * thisBlockSize, screenWidth*2, -screenHeight);
    boxies.drawRect(-screenWidth, rows/2 * thisBlockSize, screenWidth*2, screenHeight);
    boxies.cacheAsBitmap = true;
    //boxies.drawRect(-cols/2 * thisBlockSize - screenWidth, -screenHeight, screenWidth, screenHeight*2);


    //rightBox.drawRect(0, 0, 1000, 1000);

    const letterboxGroup = new PIXI.display.Group(999999999);
    letterBox.parentGroup = letterboxGroup;
    const letterboxLayer = new PIXI.display.Layer(letterboxGroup);

    letterBox.addChild(boxies);
    this.systems.letterBox = letterBox;
    this.systems.overlay.addChild(letterBox);
    this.systems.gameobjects.app.stage.addChild(letterboxLayer);
    this.systems.letterboxLayer = letterboxLayer;

  }

  }
}
export default CameraSystem;
